"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const uuid_1 = require("uuid");
const getEnrolmentOfContent_1 = tslib_1.__importDefault(require("../helpers/enrolment/getEnrolmentOfContent"));
const getContent_1 = require("../helpers/getContent");
const getContentType_1 = require("../helpers/getContentType");
const getEvaluateInteractionParam_1 = require("../helpers/getEvaluateInteractionParam");
const getCheckpointEvaluatedEvent_1 = require("../helpers/getEvent/getCheckpointEvaluatedEvent");
const getSubmissionUpdatedEvent_1 = require("../helpers/getEvent/getSubmissionUpdatedEvent");
const evaluateInteraction_1 = require("../helpers/getInteraction/evaluateInteraction");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
function updateCheckPointSubmissionDates(state, timeStamp) {
    state.lastAccessedOn = state.updatedAt = state.lastSubmittedOn = timeStamp;
}
function applyAddCheckpointSubmissionCommand(command, user, content, states, enrolments) {
    const { contentId, answers, timeStamp } = command;
    const { userId, companyId } = user;
    const events = [];
    let stateInteractions = [];
    const updatedStates = immer_1.produce(states, draftStates => {
        const currentContent = getContent_1.getContentByContentId(content, contentId);
        const contentType = getContentType_1.getContentType(currentContent);
        const state = getState_1.getStateByContentIdUserId(draftStates, contentId, userId);
        if (!Array.isArray(state.submissions)) {
            state.submissions = [];
        }
        const currentSubmission = {
            submissionId: uuid_1.v4(),
            submissionStatus: entity_1.CheckpointSubmissionStatus.PENDING,
            learnerMessage: answers[0].learnerMessage,
            responseType: answers[0].responseType,
            uploadedFileName: answers[0].uploadedFileName,
            response: answers[0].response,
            submittedOn: timeStamp
        };
        // Fetching enrolment for the current checkpoint
        const enrolment = getEnrolmentOfContent_1.default(enrolments, contentId, userId);
        /**
         * Checking if checkpoint is of auto approve type and
         * consequently generation checkpoint evaluated event
         */
        if (enrolment.reviewerType === entity_1.ReviewerType.NONE) {
            currentSubmission.submissionStatus = entity_1.CheckpointSubmissionStatus.APPROVED;
            const checkpointEvaluatedEvent = getCheckpointEvaluatedEvent_1.getCheckpointEvaluatedEvent(command, companyId, userId, contentId, contentType, entity_1.ReviewerType.NONE, undefined, entity_1.EvaluateResultType.APPROVED);
            events.push(checkpointEvaluatedEvent);
        }
        // Adding submission to state
        state.submissions.unshift(currentSubmission);
        updateCheckPointSubmissionDates(state, timeStamp);
        // Creating state interaction for possible reviewerIds from enrolment, if any
        if (enrolment.reviewerType !== entity_1.ReviewerType.GROUP) {
            const reviewerIds = (enrolment.reviewerIds || []).filter(id => !!id);
            const evaluateInteractionParams = reviewerIds.map((reviewerId) => {
                return getEvaluateInteractionParam_1.getEvaluateInteractionParam(command, user, reviewerId, currentSubmission.submissionId);
            });
            stateInteractions = evaluateInteractionParams.map(evaluateInteraction_1.evaluateInteraction);
        }
        const submissionUpdatedEvent = getSubmissionUpdatedEvent_1.getSubmissionUpdatedEvent(command, companyId, userId, contentId, contentType);
        events.push(submissionUpdatedEvent);
    });
    return { states: updatedStates, events, stateInteractions, enrolments: [] };
}
exports.applyAddCheckpointSubmissionCommand = applyAddCheckpointSubmissionCommand;
//# sourceMappingURL=applyAddCheckpointSubmissionCommand.js.map